import React, { PropsWithChildren } from 'react';

const ErrorMessage = ({ children }: PropsWithChildren<Record<string, unknown>>) => (
  <div className="position-absolute text-danger" data-testid="error" style={{ fontSize: '80%' }}>
    {children}
  </div>
);

export { ErrorMessage };
